import React, { useState, useMemo, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { useDropzone } from 'react-dropzone'
import {
  Box,
  Backdrop,
  CircularProgress,
  Button,
  Typography,
} from '@mui/material'

import Iconify from './Iconify'

function FileUpload({
  onDrop,
  uploading,
  file,
  buttonText,
  onDelete,
  isDialog,
  small = false,
  showFile = false,
}) {
  const inputFileRef = useRef()

  const baseStyle = {
    width: !isDialog ? '388px' : '',
    height: !small ? '150px' : '',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    borderWidth: 1,
    borderRadius: 5,
    borderColor: '#e3e3e3',
    borderStyle: 'dashed',
    backgroundColor: '#ffffff',
    color: '#717386',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    cursor: 'pointer',
  }

  const focusedStyle = {
    borderColor: '#2196f3',
  }

  const acceptStyle = {
    borderColor: '#00e676',
  }

  const rejectStyle = {
    borderColor: '#ff1744',
  }

  const {
    acceptedFiles,
    fileRejections,
    getRootProps,
    getInputProps,
    isFocused,
    isDragAccept,
    isDragReject,
  } = useDropzone({ onDrop: onDrop })

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject]
  )

  // ref={inputPresentationFileRef}

  const handleOpenFile = (file) => {
    window.open(file, '_blank')
  }

  return (
    <>
      {!file ? (
        <>
          <Box {...getRootProps({ style })} ref={inputFileRef}>
            <input {...getInputProps()} />
            {uploading ? (
              <CircularProgress color='inherit' />
            ) : (
              <Iconify
                icon='fe:upload'
                width={24}
                height={24}
                color='#717386'
              />
            )}
          </Box>
          <Button
            onClick={() => inputFileRef.current.click()}
            sx={[
              {
                marginTop: 2,
                backgroundColor: '#e75c25',
                boxShadow: 0,
                width: !isDialog ? '388px' : undefined,
              },
              {
                '&:hover': {
                  backgroundColor: '#e75c25',
                },
              },
            ]}
            fullWidth
            variant='contained'
            startIcon={<Iconify icon='fe:upload' />}
          >
            {buttonText}
          </Button>
        </>
      ) : (
        <>
          <Box {...getRootProps({ style })}>
            <Iconify
              icon='ion:document-attach'
              width={24}
              height={24}
              color='#717386'
            />
            <Typography
              marginTop='8px'
              fontSize='.874rem'
              maxWidth='90%'
              whiteSpace='nowrap'
              textOverflow='ellipsis'
              overflow='hidden'
              sx={{
                direction: 'rtl',
              }}
            >
              {file}
            </Typography>
          </Box>
          {!showFile ? (
            <Button
              onClick={onDelete}
              sx={[
                {
                  marginTop: 2,
                  backgroundColor: 'red',
                  boxShadow: 0,
                  width: !isDialog ? '388px' : undefined,
                },
                {
                  '&:hover': {
                    backgroundColor: 'red',
                  },
                },
              ]}
              fullWidth
              variant='contained'
              startIcon={<Iconify icon='fe:upload' />}
            >
              حذف فایل
            </Button>
          ) : (
            <Button
              onClick={() => handleOpenFile(file)}
              sx={[
                {
                  marginTop: 2,
                  boxShadow: 0,
                  width: !isDialog ? '388px' : undefined,
                },
              ]}
              fullWidth
              variant='contained'
              startIcon={<Iconify icon='fe:upload' />}
            >
              مشاهده فایل
            </Button>
          )}
        </>
      )}
    </>
  )
}

FileUpload.propTypes = {
  onDrop: PropTypes.func.isRequired,
  uploading: PropTypes.bool,
  file: PropTypes.string,
  buttonText: PropTypes.string.isRequired,
  isDialog: PropTypes.bool,
}

export default FileUpload
